export const callRequestGtm = (prod_name: string) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'sizi_arayalim_click',
    prod_name: prod_name });
};

export const callRequestSubmitGtm = (
  prod_name: string,
  currency: string,
  value: number,
) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'generate_lead',
    currency: currency,
    value: value,
    lead_source: 'Setur Web',
    tour_name: prod_name
    });
};



